const container = document.querySelector('.table-product');

if (container) {
  const overlay = container.querySelector('.right');
  const OFFSET = 0;
  let ticking = false; // Flag per ottimizzare

  function updateOverlay() {
    if (!overlay) return;

    if (window.innerWidth < 768) {
      overlay.style.transform = 'translateX(0%)';
      return;
    }

    const containerRect = container.getBoundingClientRect();
    const distanceFromBottom = containerRect.bottom - window.innerHeight;

    if (distanceFromBottom <= OFFSET) {
      overlay.style.transform = `translateX(-50%) translateY(${distanceFromBottom - OFFSET}px)`;
    } else {
      overlay.style.transform = 'translateX(-50%)';
    }
  }

  // Funzione che gestisce gli eventi per non sovraccaricare il browser
  function handleEvent() {
    if (!ticking) {
      window.requestAnimationFrame(() => {
        updateOverlay();
        ticking = false;
      });
      ticking = true;
    }
  }

  // Aggiungi i listener che richiamano il gestore ottimizzato
  window.addEventListener('scroll', handleEvent);
  window.addEventListener('resize', handleEvent);
  
  // Esegui il primo calcolo dopo il caricamento completo della pagina
  window.addEventListener('load', updateOverlay);
}